import {useEffect, useState} from 'react';

const colors = [
    '#F44336', // red
    '#E91E63', // pink
    '#9C27B0', // purple
    '#673AB7', // deep purple
    '#3F51B5', // indigo
    '#2196F3', // blue
    '#03A9F4', // light blue
    '#00BCD4', // cyan
    '#009688', // teal
    '#4CAF50', // green
    '#8BC34A', // light green
    '#FF9800', // orange
    '#795548', // brown
];
export const getRandomColor = (str: string) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
};

const hhmmss = (s: number) => new Date(s * 1000).toISOString().slice(11, 19);

export const useCallTimer = (startAt: number | null) => {
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
        if (!startAt) return;
        const id = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(id);
    }, [startAt]);

    if (!startAt) return '00:00:00';
    const seconds = Math.max(0, Math.floor((now - startAt) / 1000));
    return hhmmss(seconds);
};
